import { statesHashMap } from '@linqpal/models/src/dictionaries'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { View, Text, StyleSheet } from 'react-native'

interface BillingAddressProps {
  billingAddress: {
    addressLine1: string
    addressLine2?: string
    city: string
    stateCode: string
    zipCode: string
  }
}

export const BillingAddress: React.FC<BillingAddressProps> = ({
  billingAddress,
}) => {
  const { addressLine1, addressLine2, city, stateCode, zipCode } =
    billingAddress

  const { t } = useTranslation('global')

  const fullAddress = `${addressLine1}${
    addressLine2 ? ` ${addressLine2}` : ''
  }, ${city}, ${stateCode}(${statesHashMap[stateCode]}), ${zipCode}`

  return (
    <View style={styles.container}>
      <Text style={styles.title}>
        {t('integrations.pay-as-guest.payment-method-section.billing-address')}
      </Text>
      <Text style={styles.address}>{fullAddress}</Text>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    marginVertical: 16,
  },
  title: {
    fontWeight: '700',
    fontFamily: 'Inter',
    fontSize: 16,
    color: '#001929',
    marginBottom: 4,
    lineHeight: 28,
  },
  address: {
    fontSize: 14,
    fontFamily: 'Inter',
    fontWeight: '500',
    color: '#001929',
    lineHeight: 22,
  },
})
